import store from "@frameworks/web/redux/store";
import { ONE_PLATFORM_ERROR, ONE_PLATFORM_HIDE_ERROR, ONE_PLATFORM_START_LOADER, ONE_PLATFORM_STOP_LOADER, ONE_PLATFORM_ADD_MSG, ONE_PLATFORM_CLEAR_MSG, } from "@frameworks/web/redux/interfaces/common/iCommon";
class CommonOnePlatFormActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    setError(payload, errorType) {
        this.dispatch({
            type: ONE_PLATFORM_ERROR,
            payload: { errorData: payload },
            reducerName: errorType,
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: ONE_PLATFORM_HIDE_ERROR,
            reducerName: errorType,
        });
    }
    loader(type) {
        this.dispatch({
            type: ONE_PLATFORM_START_LOADER,
            reducerName: type,
        });
    }
    stopLoader(type) {
        this.dispatch({
            type: ONE_PLATFORM_STOP_LOADER,
            reducerName: type,
        });
    }
    addMsg(msg, show, icon, reducerName) {
        this.dispatch({
            type: ONE_PLATFORM_ADD_MSG,
            payload: { message: { msg, show, icon } },
            reducerName,
        });
    }
    clear(reducerName) {
        this.dispatch({
            type: ONE_PLATFORM_CLEAR_MSG,
            reducerName,
        });
    }
}
export default CommonOnePlatFormActions;
